import React from 'react';
import { Popup, Label, Icon } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import attachmentReasonIcon from '../helper';

const RequestAttachmentLabel = ({ attachment }) => {
  const { iconName, className, message } = attachmentReasonIcon(attachment);

  return (
    <Popup
      content={<FormattedMessage id={message} />}
      trigger={(
        <Label basic className={className}>
          <Icon name={iconName} />
          {attachment.name}
        </Label>
      )}
    />
  );
};

export default RequestAttachmentLabel;
